import { REGIONS_WITH_COUNTRIES } from "./dropdownOptions";
import { slugify } from "./countries";

export interface RegionEntry {
  name: string;
  slug: string;
  countries: string[];
}

export const REGION_ENTRIES: RegionEntry[] = Object.entries(REGIONS_WITH_COUNTRIES).map(
  ([name, countries]) => ({
    name,
    slug: slugify(name),
    countries,
  }),
);

export const REGIONS_BY_SLUG: Record<string, RegionEntry> = Object.fromEntries(
  REGION_ENTRIES.map((r) => [r.slug, r]),
);

export function regionFromSlug(slug: string | undefined): RegionEntry | null {
  if (!slug) return null;
  return REGIONS_BY_SLUG[slug.toLowerCase()] ?? null;
}
